// import {defaultContentFont, defaultContentHeaderFont, defaultMainHeaderFont, whiteColor, grayColor, blueColor, DodgerBlueColor} from '../../cmsMainStyle'

const drawingRegisterStyle = theme => ({
	formControl: {
		width: "100%",
	},

})


export default drawingRegisterStyle